import React from 'react';

interface YouTubeEmbedProps {
    url: string;
    title?: string;
    aspectRatio?: string;
}

const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({
                                                       url,
                                                       title = 'YouTube video',
                                                       aspectRatio = '16/9'
                                                   }) => {
    const getVideoId = (url: string) => {
        const match = url.match(/(?:youtu\.be\/|youtube\.com\/watch\?v=|youtube\.com\/embed\/)([^&\n?#]+)/);
        return match ? match[1] : null;
    };

    const videoId = getVideoId(url);

    if (!videoId) {
        return (
            <div className="bg-slate-100 rounded-lg p-8 text-center">
                <p className="text-slate-500">Invalid YouTube URL</p>
            </div>
        );
    }

    return (
        <div
            className="relative overflow-hidden rounded-lg bg-black"
            style={{ aspectRatio }}
        >
            <iframe
                src={`https://www.youtube.com/embed/${videoId}`}
                title={title}
                className="absolute inset-0 w-full h-full"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        </div>
    );
};

export default YouTubeEmbed;